// extracted by mini-css-extract-plugin
export default {"center":"styles_center__K8co1","marginLeftAuto":"styles_marginLeftAuto__5Jru7"};